<template>
  <!-- eslint-disable max-len -->
  <div class="page-block">
    <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">{{ isBtoC? '「narasu」': '' }}著作権管理サービス利用規約</h3>
    </div>
    <div class="page-block__inner">
      <div
        v-if="isBtoC"
        class="terms-area">
        <div class="terms-text__box">
          <p>
            本「narasu」著作権管理サービス利用規約（以下「本利用規約」といいます。）は、株式会社ローディアムが提供する著作権管理サービスの利用に関する諸条件を定めるものです。本サービス（第1条で定義します。）の利用を希望される方は、本利用規約をよくお読み頂き、全てに同意の上ご利用下さい。本サービスの登録を利用された場合、本利用規約の全ての記載内容に承諾したものとみなされます。本利用規約に同意いただけない場合、本サービスを利用することはできません。<br>
            18歳未満の方は、親権者等の法定代理人の同意が必要となります。なお、アカウント管理者等が18歳未満の場合、本サービスを利用した時点で、親権者等の法定代理人の同意が得られているものとみなします。<br><br>
            本サービスのご利用に際しては、本利用規約並びに当社が別途定める<a
              href="/client/static/copyright-assignment-terms"
              class="c-text-link"
              style="font-weight:bold;"
              target="_blank">音楽著作権の期間及び限定譲渡に関する規約（著作権管理サービス）</a>（以下「著作権管理サービス利用規約」といいます。）及びサブスクリプション型音楽配信代行サービス「narasu」利用規約（以下「narasu利用規約」といいます。）等その他の規約（以下併せて「関連規約」といいます。）が適用されます。当社ウェブサイトに掲載される本利用規約及び関連規約の最新版を、随時ご確認ください。本利用規約と関連規約が矛盾抵触する場合は、関連規約が優先して適用されるものとします。
          </p>
        </div>

        <h4>第１条：定義</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>「当社」とは、株式会社ローディアムをいいます。</li>
            <li>「本サービス」とは、当社が本利用規約及び関連規約に基づき提供する著作権管理サービスをいいます。</li>
            <li>「アカウント」とは、本サービスを利用するために必要な仮想口座「narasuアカウント」をいいます。アカウントは、アカウント管理者ごとに開設され、管理著作物使用料（第5条で定義します。）その他のアカウント管理者等が受領権限を有する金額をプラス計上し、手数料その他当社が収受すべき金額をマイナス計上します。なお、アカウントの残高には利息はつきません。</li>
            <li>「アカウント管理者」とは、本利用規約に同意の上、本サービスへの登録の申込をされた方であって、当社が当該申込を承諾した方をいいます。なお、本サービス上において、「管理者」と表記する場合があります。</li>
            <li>「アカウントメンバー」とは、アカウント管理者により本サービスの利用の招待を受け、本利用規約に同意の上、本サービスへの登録の申込をされた方であって、当社が当該申込を承諾した方をいい、当該アカウント管理者に開設されたアカウントに紐づけられる方をいいます。なお、本サービス上において、「ゲスト」と表記する場合があります。</li>
            <li>「アカウント管理者等」とは、アカウント管理者とアカウントメンバーの総称をいいます。</li>
            <li>「コンテンツ」とは、アカウント管理者が本サービスに登録又は提供（アップロードを含む）した楽曲・歌詞を含む音楽作品をいいます。</li>
            <li>「著作権等管理事業者」とは、著作権等管理事業法（平成12年法律第131号）に定義される著作権等管理事業者をいいます。</li>
          </ol>
        </div>

        <h4>第２条：本サービス</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本サービスの一環として、アカウント管理者は自身の管理画面において管理著作物使用料を確認することができます。</li>
            <li>本サービスは、日本語を十分に理解し読み書きができる、日本国内在住の個人又は日本国内に事業拠点を有する法人を対象とします。</li>
            <li>アカウント管理者等は、以下の事項を表明・保証します。本サービスの提供は、これらの表明・保証が全て正確かつ真実であること、及びアカウント管理者が本利用規約を遵守することを条件とします。</li>
            <ul>
              <li>(1)アカウント管理者等が、本サービスの登録・利用を行うために必要な、完全な権利及び権限を有すること。</li>
              <li>(2)アカウント管理者等が、日本国内在住の個人又は日本国内に事業拠点を有する法人であること。</li>
              <li>(3)本利用規約に従ったアカウント管理者等による本サービスの登録・利用（支払の受領、及び利用の停止・中止を含みます。以下本条において同じです。）、並びに、本サービスに係るコンテンツの利用（当社及びそのライセンシー及び利用者による利用を含みます。以下本条において同じです。）が、法令及びアカウント管理者等と第三者とのいかなる契約その他の合意にも抵触せず、違反又は債務不履行を構成しないこと。</li>
              <li>(4)アカウント管理者以外にコンテンツの著作権者（アカウントメンバーを含みます。）がいる場合、アカウント管理者は当該著作権者から、本利用規約に従ったアカウント管理者による本サービスの登録・利用、並びに本サービスに係るコンテンツの利用に必要な、一切の授権を取得済みであること。</li>
              <li>(5)アカウント管理者等が本利用規約に基づき、又は本サービスに関連して提供する情報は、全て正確であること。</li>
            </ul>
          </ol>
        </div>

        <h4>第３条：著作権登録</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>アカウント管理者は、narasu利用規約に基づくアカウント登録をおこなった上で、本サービスの対象とすることを希望するコンテンツにつき、当社所定のフォームよりコンテンツの登録を行い、その上で、当社の審査を経て承認された場合にのみ、当該コンテンツは著作権管理サービス利用規約に基づいて当社に著作権が譲渡され、本サービスの対象となります。なお、本利用規約又は関連規約に定める場合を除き、いかなる理由でもコンテンツの登録後にコンテンツの登録をキャンセルすることは出来ません。なお、本サービスの利用停止については、別途当社にお問い合わせください。</li>
            <li>アカウント管理者は、コンテンツが著作権等管理事業者等の定める条件に合致しない場合、その他当社が不適当と判断した場合に、当社が当該コンテンツの登録を承認しないことを了承するものとします。</li>
            <li>アカウント管理者は、第1項に従い登録された各コンテンツにつき、本サービス利用の対価として、当社が定める登録管理手数料を支払います。登録管理手数料の詳細は、著作権管理サービス利用規約によるものとします。</li>
          </ol>
        </div>

        <h4>第４条：コンテンツについて</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>アカウント管理者は、当社及び当社から許諾された第三者が本サービスの提供に関連して（コンテンツの販売促進及び本サービスの広告宣伝を含みます）、コンテンツに含まれる情報等を無償で使用することを了承するものとします。</li>
            <li>アカウント管理者は、当社及び当社から許諾された第三者に対して、自ら又は第三者（アカウントメンバーを含みます。）をして著作者人格権を行使しないことに同意するものとします。</li>
            <li>アカウント管理者は、登録又は提供するコンテンツに関し、当社に対し以下を保証するものとします。</li>
            <ul>
              <li>(1)コンテンツに関する著作権・著作隣接権・肖像権その他一切の権利について、正当な権利者であること、又は、正当な権利者から本サービスに係るコンテンツの著作権の譲渡を受けていること。</li>
              <li>(2)本サービスに係るコンテンツの利用が、第三者の著作権・著作隣接権・肖像権その他一切の権利を侵害しないこと。</li>
            </ul>
            <li>アカウント管理者は、コンテンツに関して当社に対して第三者から異議・苦情等の申立又は損害賠償等の請求があった場合には、自らの責任と費用負担において処理するものとし、当社に一切損害を発生させないものとします。</li>
            <li>アカウント管理者等は、本サービスを利用したことに起因して（当社がかかる利用を原因とするクレームを第三者より受けた場合を含みます。）、当社が直接的又は間接的に何らかの損害（弁護士費用の負担を含みます。）を被った場合、当社の請求に従って直ちにこれを賠償しなければなりません。</li>
            <li>アカウント管理者は、以下の内容を含むコンテンツを登録又は提供（アップロードを含む）してはならないものとします。</li>
            <ul>
              <li>(1)第三者の有する著作権・著作隣接権・肖像権・その他の権利を侵害する又はそのおそれのあるもの</li>
              <li>(2)犯罪行為、違法行為を肯定する内容を含むもの</li>
              <li>(3)公序良俗に反する又はそのおそれがあるもの</li>
              <li>(4)差別的表現、未成年者にとって有害と認められる情報を含むもの</li>
              <li>(5)その他当社が不適切と判断するもの</li>
            </ul>
            <li>アカウント管理者等は、本サービスを、当該サービスを通じた著作権管理の目的のみに利用するものとし、それ以外の目的（当社以外による同種又は類似サービスの開発・検討等を含みます）に本サービス（当該サービスを通じて得られるデータ、ノウハウ等を含みます）を利用することは禁止します。また、本サービス利用期間中及びその後1年間、本サービスと競合するサービスを開発又は競合するサービスに従事することを目的として利用、解析等を行うことも禁止されます。これらの禁止行為を行った場合は本利用規約違反となり、当社は直ちに当該サービス又はアカウントの利用停止・中止、当該サービスの利用契約の解除その他必要と認める措置及び損害賠償請求を行うことができるものとします。</li>
          </ol>
        </div>

        <h4>第５条：管理著作物使用料等</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>「管理著作物使用料」とは、当社が登録されたコンテンツに関し、著作権等管理事業者等の報告等に基づき受領した著作物使用料の金額から所定の登録管理手数料を差し引いた金額をいいます。詳細は、当社が別途定める音楽著作権の期間及び限定譲渡に関する規約（著作権管理サービス）によるものとします。なお、当社はかかる著作物使用料が著作権等管理事業者等から任意に支払われない場合、これを取立あるいは回収する義務を負わないものとします。</li>
            <li>当社は、著作権等管理事業者等の報告等に基づき受領した著作物使用料をアカウントに計上のうえ、当社所定の方法によるアカウント管理者からの支払要請があるまで当社の口座で保管することとし、アカウント管理者は当社が保管するこの著作物使用料に利子やその他配当等がつかないことを了承することとします。なお、著作物使用料に1円未満の端数がある場合、当社はアカウントに計上しないことができます。</li>
            <li>アカウント管理者は、当該アカウントに関してアカウントメンバーが存在する場合、当社所定の方法により、アカウント管理者とアカウントメンバーとの間における管理著作物使用料の配分率を設定することができます。</li>
            <li>アカウント管理者（アカウント管理者が前項の規定に基づき配分率を設定した場合は、本条において以下アカウントメンバーを含みます。）は当社に対し、当社所定の方法により、管理著作物使用料の支払要請をすることができます。</li>
            <li>当社は、当社がアカウント管理者の支払要請（ただし、支払前の残高が当社所定の基準額を上回る場合に限ります。）を確認後1ヶ月以内に、アカウント残高の内、アカウント管理者が指定した金額を、アカウント管理者が当社所定の方法であらかじめ登録した銀行口座に振込む方法により支払うものとします。なお、振込みに必要な銀行手数料は、アカウント管理者が負担するものとします。また、登録された口座情報の不備により当社が振込みをできなかった場合、銀行の組み戻し費用はアカウント管理者が負担するものとします。</li>
            <li>アカウント管理者は、著作権等管理事業者等において、管理著作物使用料の過払い額その他の調整が行われる場合があることを了承するものとします。この場合、当社は、アカウント管理者のアカウント残高から調整額を差し引くものとし、アカウント管理者はこれを了承するものとします。</li>
            <li>アカウント管理者が支払いを受けた管理著作物使用料は、アカウント管理者の責任と負担において、その他の正当な権利者へ配分するものとします。当社は、アカウント管理者に支払った後の管理著作物使用料の配分について一切の責任を負いません。</li>
          </ol>
        </div>

        <h4>第６条：禁止事項</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>アカウント管理者等は以下の行為を行なってはならないものとします。</li>
            <ul>
              <li>(1)本利用規約又は関連規約に違反する行為</li>
              <li>(2)法令、条例等に違反する行為</li>
              <li>(3)公序良俗に反する行為</li>
              <li>(4)当社若しくは第三者の著作権・著作隣接権・肖像権、商標権その他一切の権利を侵害する行為又は侵害するおそれのある行為</li>
              <li>(5)当社若しくは第三者の権利、利益、名誉、信用等を損ねる行為</li>
              <li>(6)当社若しくは第三者の名称を無断で使用するなどして当社若しくは第三者になりすます行為</li>
              <li>(7)第三者が権利を有する楽曲を権利者に無断で登録又は提供（アップロードを含む）する行為</li>
              <li>(8)不正な方法により楽曲又は動画の再生回数を増やす行為</li>
              <li>(9)第三者の個人情報を収集する行為</li>
              <li>(10)政治団体、宗教団体への勧誘行為</li>
              <li>(11)リバースエンジニアリング、その他本サービスのソースコード、構造等を解析する行為</li>
              <li>(12)本サービスのサーバーその他設備への不正アクセス、スパムメールの送信等、本サービスの提供を妨げる行為</li>
              <li>(13)前各号の行為を試みること</li>
              <li>(14)その他当社が不適切と判断する行為</li>
            </ul>
            <li>アカウント管理者は、以下のコンテンツを本サービスの対象として登録又は提供（アップロードを含む）してはならないものとする。</li>
            <ul>
              <li>(1)第三者の著作権・著作隣接権・肖像権その他一切の権利を侵害しているコンテンツ</li>
            </ul>
            <li>アカウント管理者等が前二項のいずれかに違反し、若しくはアカウント管理者等にnarasu利用規約第3条（アカウント登録）第2項所定の事由が判明し、又はそれらのおそれがあるものと当社が判断した場合、当社は、事前にアカウント管理者等に通知することなくアカウント管理者等のアカウントの凍結（その場合、アカウントの残高支払要請及び削除ができなくなります）又は抹消、本サービスの提供又は管理著作物使用料の支払いの停止、コンテンツ登録又は本サービスにかかる契約の解除その他当社が適切と判断する措置をとることができるものとします。当社は、これらの措置によりアカウント管理者等が被った損害について一切の責任を負いません。なお、当社が事実関係の確認のための調査が必要と判断した場合、当社は必要な調査を行うことができるものとし、アカウント管理者等は調査に協力するものとします。</li>
            <li>アカウント管理者等は、本条第1項のいずれかに違反した場合、当社又は第三者が被った損害について賠償するものとします。</li>
          </ol>
        </div>

        <h4>第７条：本サービスの中止、停止</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、以下のいずれかの事由が発生した場合には、本サービスの全部又は一部の提供を停止することができるものとします。その場合、当社の裁量によりアカウントを凍結することができます。</li>
            <ul>
              <li>(1)設備等のメンテナンスを行う場合。</li>
              <li>(2)天災地変等の不可抗力の場合。</li>
              <li>(3)通信回線の障害等の事故があった場合。</li>
              <li>(4)法令等により本サービスの提供ができない場合。</li>
              <li>(5)その他当社が必要と判断した場合。</li>
            </ul>
            <li>前項にかかわらず、当社は、原則として3ヶ月前までにアカウント管理者等に通知することにより、本サービスの提供を中止することができるものとします。その場合、当社の裁量によりアカウントを抹消することができます。</li>
            <li>当社は、本サービスの全部又は一部の提供の停止又は中止に起因してアカウント管理者が被った損害について、一切の責任を負いません。</li>
          </ol>
        </div>

        <h4>第８条：アカウントの抹消・凍結等</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、アカウント管理者等に下記の事由が生じた場合（なお、アカウント管理者等が複数存在する場合、その一部について当該事由が生じた場合も含みます。）、何等の通知・催告なしにアカウントを抹消若しくは凍結又は本サービスに係る契約の解除をすることができるものとします。</li>
            <ul>
              <li>(1)破産、民事再生、会社更生若しくは特別清算の手続が開始し、又はその申立て（本人による申立て準備を含む）があった場合</li>
              <li>(2)解散又は清算を決議した場合</li>
              <li>(3)支払いを停止し、又は手形交換所の取引停止処分を受けた場合</li>
              <li>(4)仮差押、差押若しくは競売の申立てを受けた場合</li>
              <li>(5)租税公課を滞納し督促を受け、又は保全差押を受けた場合</li>
              <li>(6)監督官庁から営業停止などの処分を受けた場合</li>
              <li>(7)その他、当社が本サービスを継続しがたい事情があると認めた場合</li>
            </ul>
            <li>当社は、前項各号の事由が生じた場合、本サービスの全部又は一部の提供を中止・停止することもできるものとします。</li>
            <li>当社は、前各項の措置に起因してアカウント管理者等が被った損害について、一切の責任を負いません。</li>
          </ol>
        </div>

        <h4>第９条：通知・連絡</h4>
        <div class="terms-text__box">
          当社がアカウント管理者等に対して通知・連絡を行う場合、アカウント管理者等が当社所定の方法で当社に届け出たアドレス宛ての電子メールの送付をもってアカウント管理者等は当該通知・連絡を受領したものとみなします。
        </div>

        <h4>第１０条：業務の委託</h4>
        <div class="terms-text__box">
          当社は、本サービスの一部を当社が選定した第三者に委託することができるものとします。
        </div>

        <h4>第１１条：権利の帰属</h4>
        <div class="terms-text__box">
          本サービスにおいて当社が提供する著作物、素材、情報等に関する著作権その他一切の権利は、当社又は権利を有する第三者に帰属するものとします。アカウント管理者等は、これらの権利を侵害する行為（無断複製、改変、頒布、配信等を含みます）を行うことができません。
        </div>

        <h4>第１２条：機密情報</h4>
        <div class="terms-text__box">
          アカウント管理者等は、本サービスの利用にあたり知り得た当社又は第三者の技術上・業務上の機密を本サービス利用の目的外に使用してはならず、当社の書面による事前同意がない限り第三者に開示・漏洩してはならないものとします。
        </div>

        <h4>第１３条：免責・不保証</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、本サービス内に、欠陥・バグ・不具合その他の瑕疵がないこと、コンピューターウィルス等の破壊的構成物が含まれないことを保証しないものとします。</li>
            <li>当社は、本サービスにおいて当社が提供する情報等について、その正確性、信頼性、完全性、適法性、有効性、目的適合性等を保証しないものとします。</li>
            <li>当社は、アカウント管理者等が本サービスの利用又は利用できなかったことにより、アカウント管理者等が被った損害について、当社の故意・重過失によるものを除き、一切の責任を負わないものとします。</li>
            <li>本サービスに関連して当社がアカウント管理者等に対して負担する責任は、事由の如何を問わず、責任原因の発生前1年間において当社が現実に支払を受けた、コンテンツに係る本サービス提供の対価（なお、アカウント管理者等に支払われるべき管理著作物使用料は含みません。）の総額を上限とします。</li>
          </ol>
        </div>

        <h4>第１４条：個人情報</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>当社は、アカウント管理者等が本サービスの利用に際して提供した個人情報を、個人情報保護法及び当社のプライバシーポリシーに従い取り扱うものとします。</li>
            <li>当社は、本サービスの提供により取得した個人情報を以下の目的で利用致します。</li>
            <ul>
              <li>(1)著作権の著作権管理事業団体又は事業者への作品登録</li>
              <li>(2)管理著作物使用料の徴収と分配</li>
              <li>(3)アカウント管理者等への使用料明細の提出</li>
              <li>(4)コンテンツの利用促進</li>
              <li>(5)コンテンツのプロモーション活動</li>
              <li>(6)本サービスの利用者へのお問い合わせ対応</li>
            </ul>
            <li>当社では、本サービスの提供に必要な業務を外部事業者に委託することがあります。委託業務には、例えば以下のものがあります。</li>
            <ul>
              <li>(1)本サービスの利用料等の決済業務</li>
              <li>(2)本サービスの保守・メンテナンス業務</li>
              <li>(3)本サービスのサーバー管理業務</li>
            </ul>
          </ol>
        </div>

        <h4>第１５条：権利義務の譲渡の禁止</h4>
        <div class="terms-text__box">
          アカウント管理者等は、本利用規約上のアカウント管理者等たる地位、本利用規約及び本サービスに関する全ての権利及び義務を、全部か一部かを問わず、第三者に譲渡し又は担保に供する等してはならないものとします。
        </div>

        <h4>第１６条：規約の変更</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本利用規約は、当社の判断により事前の通知なく随時変更を行うことができるものとします。</li>
            <li>本利用規約を変更する場合、当社はその旨を変更後の規約の内容及び変更の効力発生日とともに、本サービスに係る当社所定のウェブサイト上に掲示し、又はアカウント管理者等に通知するものとします。アカウント管理者等はかかる掲示ないし通知を定期的に確認するものとします。</li>
            <li>
              本利用規約の変更後に、本サービスを利用することにより、アカウント管理者等は変更後の利用規約の全ての記載内容を承諾したものとみなされます。
            </li>
          </ol>
        </div>

        <h4>第１７条：分離可能性</h4>
        <div class="terms-text__box">
          本利用規約のいずれかの条項又はその一部が、法令等により無効又は執行不能と判断された場合であっても、本利用規約の規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
        </div>

        <h4>第１８条：準拠法・管轄裁判所</h4>
        <div class="terms-text__box">
          <ol class="numbered">
            <li>本利用規約は日本法に基づいて解釈されるものとします。</li>
            <li>本サービス及び本利用規約に起因し、又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
          </ol>
        </div>

        <p>本利用規約は2024年4月16日より実施します。</p>
        <p>2024年4月1日制定</p>

        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'index' }"
            class="c-btn c-btn--back">
            トップへ戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
    <!-- eslint-enable max-len -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'CopyrightTerms',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>

<style lang="scss" scoped>
  ol.numbered{
    margin-left: 1.2em;
    & > li{
    list-style: decimal;
      }
  }
</style>
